import _ from 'lodash';
import {
  INIT_ROOT,
  CMS_SCRIPT_LOADED,
  SHOPPING_LINKS_LOADED
} from '../actionTypes';

export default function mobileByoUrl(state, action) {
  var payload = action.payload;

  switch (action.type) {
    case INIT_ROOT:
      return _.get(payload.appResources.urls, 'mobileBaseUrl');
    case CMS_SCRIPT_LOADED:
    case SHOPPING_LINKS_LOADED:
      return action.payload.mobileByo;
    default:
      return state || '';
  }
}
